var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"d-flex align-start"},[_c('div',[_c('div',{staticClass:"text-body-1"},[_vm._t("default")],2)]),_c('v-spacer'),_c('div',{staticClass:"text-body-2 font-weight-bold"},[_vm._t("value")],2)],1),_c('div',{staticClass:"text-caption"},[_vm._t("append")],2),_c('v-divider',{staticClass:"my-4"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }